import { useState, useRef, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { InputAdornment, FormControl, TextField, Collapse, IconButton, Box, Autocomplete } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { CountryCodes } from 'components/modalKYX/CountryCodes';
import { Designations } from 'components/modalKYX/Designations';
import { makeStyles } from '@mui/styles';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { US_SSN_REGEX, US_SSN_REGEX_TEST, ENVIRONMENT, US_POSTAL_CODE_REGEX } from 'helpers/constants';
import dayjs from 'dayjs';
import { emailValid, onlyNumber } from 'helpers/signInValidation';
import { validatePhoneNumber } from 'lib/api/owners';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { isUsaZip } from 'helpers/zips';
const { NODE_ENV } = process.env;

const useStyles = makeStyles(theme => ({
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%'
    },
    content: {
        margin: '2em',
        width: '40em'
    },
    contentTitle: {
        fontWeight: '700!important'
    },
    phoneBox: {
        marginTop: '2em'
    },
    phoneInput: {
        width: '50%'
    },
    verifyButton: {
        color: 'white!important',
        borderRadius: '25px!important',
        padding: '.5em 3em!important',
        margin: '.5em!important',
        background: '#1BABE2!important'
    },
    inputFormControl: {
        background: '#FFFFFF',
        border: '1px solid #D8DDE2',
        boxSizing: 'border-box',
        borderRadius: '3px',
        marginTop: '10px',
        width: '100%!important',
        height: '40px'
    },
    contactInforFormLabel: {
        color: '#225384',
        fontWeight: 600
    },
    businessAdressBox: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2,1fr)',
        gridColumn: '1 / span 2',
        rowGap: '.5em',
        columnGap: '1em'
    },
    formControl: {
        width: '100%!important'
    },
    informationOptions: {
        marginTop: '5em',
        paddingBottom: '2em',
        display: 'flex',
        justifyContent: 'space-between'
    },
    next: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 3em!important',
        background: '#1BABE2!important'
    },
    businessOwnerFields: {
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '1em'
        },
        [theme.breakpoints.up('md')]: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2,1fr)',
            gridRowGap: '.5em',
            gridColumnGap: '1em'
        }
    },
    hr: {
        flexGrow: 1,
        height: '1px',
        alignSelf: 'center',
        marginLeft: '0.2em'
    },
    input: {
        padding: '8.5px 14px'
    },
    inputOwnership: {
        '& input[type="number"]::-webkit-inner-spin-button, & input[type="number"]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            '-moz-appearance': 'none',
            appearance: 'none',
            margin: 0
        }
    }
}));

export default function AddOwner({
    owner,
    number,
    setOwnersArray,
    lbl,
    setSelectedIndex,
    selectedIndex,
    selectedOption,
    removeOwner,
    setTotalOwnership,
    totalOwnership,
    setErrorOwnership
}) {
    const classes = useStyles();
    const [open, setOpen] = useState(true);
    const [ageAlert, setAgeAlert] = useState(false);
    const [invalidDateAlert, setInvalidDateAlert] = useState(false);
    const [showSSN, setShowSSN] = useState(false);
    const [verifyPhone, setVerifyPhone] = useState(false);
    const [errorPostal, setErrorPostal] = useState(false);
    const [errorSSN, setErrorSSN] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const [errorOwnershipChild, setErrorOwnershipChild] = useState(false);
    const [dirtyPhone, setDirtyPhone] = useState(false);
    const phoneValid = useRef(false);
    const ssnValidation = NODE_ENV === ENVIRONMENT.DEVELOPMENT ? US_SSN_REGEX_TEST : US_SSN_REGEX;

    const verifySSNFormat = () => {
        let ssn = owner.ssn;

        if (!ssnValidation.test(ssn)) {
            setErrorSSN(true);
        } else {
            setErrorSSN(false);
        }
    };

    useEffect(() => {
        if (verifyPhone) {
            if (owner.phone_number.length < 10) {
                setErrorPhone('PHONE_REQUIRED');
                phoneValid.current = false;
                forceNewValidation();
                return;
            }
            phoneValid.current = false;
            forceNewValidation();
            validatePhoneNumber(owner.phone_number)
                .then(result => {
                    setVerifyPhone(false);
                    if (result) {
                        setErrorPhone(false);
                        phoneValid.current = true;
                        forceNewValidation();
                        return;
                    }
                    phoneValid.current = false;
                    forceNewValidation();
                    setErrorPhone('PHONE_NOT_AVAILABLE');
                    return;
                })
                .catch(() => setVerifyPhone(false));
        }
    }, [verifyPhone]);

    const verifyPostalCodeFormat = () => {
        let postalCode = owner.bus_PO;

        if (isUsaZip(postalCode) && US_POSTAL_CODE_REGEX.test(postalCode)) {
            setErrorPostal(false);
        } else {
            setErrorPostal(true);
        }
    };

    const isFormValid = oOwner => {
        return (
            ssnValidation.test(oOwner.ssn) &&
            !!oOwner.title &&
            !!oOwner.ownership &&
            !!oOwner.first_name &&
            !!oOwner.last_name &&
            oOwner.phone_number.length === 10 &&
            dayjs(oOwner.date_of_birth).isValid() &&
            emailValid(oOwner.email) &&
            !!oOwner.bus_line_1 &&
            !!oOwner.bus_city &&
            !!oOwner.bus_state &&
            isUsaZip(oOwner.bus_PO) &&
            US_POSTAL_CODE_REGEX.test(oOwner.bus_PO)
        );
    };

    const forceNewValidation = () => {
        setOwnersArray(currentOwners => {
            const owners = [...currentOwners];
            const newOwner = { ...owners[number] };
            newOwner.isValid = isFormValid(newOwner);
            owners[number] = newOwner;
            return owners;
        });
    };

    const handleChangeInput = (field, value) => {
        setOwnersArray(currentOwners => {
            const owners = [...currentOwners];
            const newOwner = { ...owners[number] };
            newOwner[field] = value;
            newOwner.isValid = isFormValid(newOwner);
            owners[number] = newOwner;
            return owners;
        });
    };

    const remove = () => {
        removeOwner(owner);
    };

    const phoneHelperText = () => {
        if (!dirtyPhone) return null;
        switch (errorPhone) {
            case 'PHONE_REQUIRED':
                return 'Phone number is required';
            case 'PHONE_NOT_AVAILABLE':
                return 'This phone is already in use';
            default:
                return null;
        }
    };

    const convertDate = date => {
        let validDate = dayjs(date);
        if (!validDate.isValid()) {
            handleChangeInput('date_of_birth', null);
            return;
        }
        const today = dayjs();
        let age = today.diff(validDate, 'year');
        if (age >= 18) {
            setAgeAlert(false);
            handleChangeInput('date_of_birth', validDate.format('YYYY-MM-DD'));
        } else {
            setAgeAlert(true);
            handleChangeInput('date_of_birth', null);
        }
    };

    const codeToState = code => {
        if (!code) return '';
        return CountryCodes.filter(item => item.label === code)[0];
    };

    const isErrorInvalid = (owner.email && !emailValid(owner.email)) || false;

    useEffect(() => {
        if (totalOwnership > 100) {
            setErrorOwnership(true);
            setErrorOwnershipChild(true);
        } else {
            setErrorOwnership(false);
            setErrorOwnershipChild(false);
        }
    }, [owner, totalOwnership]);

    return (
        <div style={{ margin: '1em 0' }} id={`owner-${number}`}>
            <Box
                sx={{
                    cursor: 'pointer',
                    display: 'grid',
                    gridTemplateColumns: 'auto min-content'
                }}>
                <Box
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    onClick={() => setOpen(!open)}
                    sx={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        zIndex: '0'
                    }}>
                    {open ? (
                        <ExpandLess
                            style={{
                                color: '#7D95A5',
                                fontWeight: '700'
                            }}
                        />
                    ) : (
                        <ExpandMore
                            style={{
                                color: '#7D95A5',
                                fontWeight: '700'
                            }}
                        />
                    )}
                    <Typography variant="subtitle3" sx={{ textTransform: 'uppercase' }}>
                        Business owner {lbl}
                    </Typography>
                    <hr className={classes.hr} />
                </Box>
                {!owner.completed && (
                    <div>
                        {number !== 0 && !selectedOption ? (
                            <IconButton disabled={owner.completed} sx={{ zIndex: '1' }} onClick={() => remove()}>
                                <CloseIcon sx={{ color: '#7D95A5', fontWeight: '700' }} />
                            </IconButton>
                        ) : number >= 0 && selectedOption ? (
                            <IconButton disabled={owner.completed} sx={{ zIndex: '1' }} onClick={() => remove()}>
                                <CloseIcon sx={{ color: '#7D95A5', fontWeight: '700' }} />
                            </IconButton>
                        ) : null}
                    </div>
                )}
            </Box>
            <Collapse in={open} timeout="auto">
                <Box>
                    <Box className={classes.businessOwnerFields}>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Legal First Name</Typography>
                                <TextField
                                    placeholder="Enter first name"
                                    variant="outlined"
                                    onChange={e => {
                                        handleChangeInput('first_name', e.target.value);
                                    }}
                                    value={owner.first_name}
                                    size="small"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Legal Last Name</Typography>
                                <TextField
                                    placeholder="Enter last name"
                                    variant="outlined"
                                    onChange={e => {
                                        handleChangeInput('last_name', e.target.value);
                                    }}
                                    value={owner.last_name}
                                    size="small"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Email Address</Typography>
                                <TextField
                                    placeholder="Enter email address"
                                    variant="outlined"
                                    onChange={e => {
                                        handleChangeInput('email', e.target.value);
                                    }}
                                    error={isErrorInvalid}
                                    value={owner.email}
                                    size="small"
                                />
                                {isErrorInvalid ? (
                                    <Typography sx={{ color: 'red', fontSize: '.75rem' }}>
                                        Please, enter a correct email address.
                                    </Typography>
                                ) : null}
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Enter Phone</Typography>
                                <TextField
                                    size="small"
                                    disabled={owner.completed}
                                    onChange={e => {
                                        setDirtyPhone(true);
                                        if (onlyNumber(e.target.value)) {
                                            setErrorPhone(false);
                                            handleChangeInput('phone_number', e.target.value);
                                        }
                                        phoneValid.current = false;
                                    }}
                                    onBlur={e => {
                                        if (e.target.value.length === 10) {
                                            return setVerifyPhone(true);
                                        }
                                        if (e.target.value.length > 0 && e.target.value.length < 10) {
                                            setErrorPhone('PHONE_REQUIRED');
                                        }
                                    }}
                                    error={dirtyPhone && (!!errorPhone || !phoneValid)}
                                    value={owner.phone_number}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography> +1 </Typography>
                                            </InputAdornment>
                                        )
                                    }}
                                    inputProps={{
                                        maxLength: 10
                                    }}
                                    helperText={phoneHelperText()}
                                    variant="outlined"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Relationship to the Company</Typography>
                                <Autocomplete
                                    disablePortal
                                    id="bus_job_title"
                                    autoSelect={true}
                                    options={Designations}
                                    sx={{ gridColumn: '2/3' }}
                                    renderInput={params => <TextField {...params} placeholder="Select job title" />}
                                    onChange={(event, option) => {
                                        handleChangeInput('title', option.label);
                                        handleChangeInput('designation', option.value);
                                    }}
                                    getOptionLabel={option => option?.label || ''}
                                    value={Designations.find(designation => designation.value === owner.designation)}
                                    size="small"
                                    variant="outlined"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">% Beneficial Ownership</Typography>
                                <TextField
                                    placeholder="Enter %"
                                    variant="outlined"
                                    error={errorOwnershipChild}
                                    onChange={e => {
                                        handleChangeInput('ownership', e.target.value);
                                    }}
                                    type="number"
                                    onBlur={e => {
                                        let value = Math.round(e.target.value);
                                        if (value < 1) {
                                            value = 1;
                                        } else if (value > 100) {
                                            value = 100;
                                        }
                                        e.target.value = value;
                                        handleChangeInput('ownership', e.target.value);
                                    }}
                                    value={owner.ownership}
                                    helperText={errorOwnershipChild ? 'Total ownership must be less than 100' : ''}
                                    size="small"
                                    className={classes.inputOwnership}
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Date Of Birth</Typography>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        error={invalidDateAlert || ageAlert}
                                        inputFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        value={owner?.date_of_birth}
                                        onChange={e => convertDate(e)}
                                        renderInput={params => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                            {ageAlert ? (
                                <Typography sx={{ color: 'red', fontSize: '.75rem' }}>
                                    You must be 18 years or older to register.
                                </Typography>
                            ) : null}
                            {invalidDateAlert ? (
                                <Typography sx={{ color: 'red', fontSize: '.75rem' }}>Please enter a valid date.</Typography>
                            ) : null}
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Social Security Number (SSN)</Typography>
                                <TextField
                                    error={errorSSN}
                                    name="bus_SSN"
                                    placeholder="Enter SSN"
                                    onBlur={() => verifySSNFormat()}
                                    classes={{ input: classes.input }}
                                    onChange={e => {
                                        if (onlyNumber(e.target.value)) {
                                            handleChangeInput('ssn', e.target.value);
                                        }
                                    }}
                                    value={owner.ssn}
                                    required
                                    InputProps={{
                                        sx: { height: '40px' },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="Toggle SSN visibility"
                                                    onClick={() => setShowSSN(!showSSN)}
                                                    edge="end">
                                                    {!showSSN ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    inputProps={{
                                        maxLength: 9
                                    }}
                                    type={showSSN ? 'text' : 'password'}
                                />
                                {errorSSN ? (
                                    <Typography sx={{ color: 'red', fontSize: '.75rem' }}>
                                        Please, enter a correct SSN.
                                    </Typography>
                                ) : null}
                            </FormControl>
                        </Box>
                        <Box flexDirection="column" style={{ gridColumn: '1/3' }}>
                            <FormControl className={classes.formControl}>
                                <Typography variant="subtitle2">Residential Address</Typography>
                                <TextField
                                    placeholder="Street line 1"
                                    variant="outlined"
                                    onChange={e => {
                                        handleChangeInput('bus_line_1', e.target.value);
                                    }}
                                    value={owner.bus_line_1}
                                    size="small"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column" style={{ gridColumn: '1/3' }}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    placeholder="Street line 2"
                                    variant="outlined"
                                    onChange={e => {
                                        handleChangeInput('bus_line_2', e.target.value);
                                    }}
                                    value={owner.bus_line_2}
                                    size="small"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <TextField
                                    placeholder="City"
                                    variant="outlined"
                                    onChange={e => {
                                        handleChangeInput('bus_city', e.target.value);
                                    }}
                                    value={owner.bus_city}
                                    size="small"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <Autocomplete
                                    disablePortal
                                    id="state"
                                    autoSelect={true}
                                    options={CountryCodes}
                                    sx={{ gridColumn: '2/3' }}
                                    renderInput={params => <TextField {...params} placeholder="State" />}
                                    getOptionLabel={option => option?.value || ''}
                                    onChange={(e, newVal) => {
                                        handleChangeInput('bus_state', newVal ? newVal.label : '');
                                    }}
                                    value={codeToState(owner.bus_state)}
                                    size="small"
                                    variant="outlined"
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <TextField
                                    error={errorPostal}
                                    name="bus_PO"
                                    size="small"
                                    placeholder="Postal Code"
                                    onBlur={verifyPostalCodeFormat}
                                    onChange={e => {
                                        handleChangeInput('bus_PO', e.target.value);
                                    }}
                                    onInput={e => {
                                        e.target.value = e.target.value.length > 5 ? e.target.value.slice(0, 5) : e.target.value;
                                    }}
                                    value={owner.bus_PO}
                                    helperText={
                                        errorPostal ? 'This zip code is not valid, a 5-digit U.S. zip code is required.' : ''
                                    }
                                />
                            </FormControl>
                        </Box>
                        <Box flexDirection="column">
                            <FormControl className={classes.formControl}>
                                <TextField disabled value="USA" name="bus_region" size="small" />
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            </Collapse>
        </div>
    );
}
